






































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import PageCard from '@/components/page-card.vue'
import Youtube from '@/store/entities/youtube'
import simplifyString from "simplify-string";
class  YoutubePageRequest extends PageRequest{
    keyword:string;
}

@Component({
    components:{PageCard}
})
export default class YoutubeVideos extends AbpBase{
    //filters
    pagerequest:YoutubePageRequest=new YoutubePageRequest();
    youtube:Youtube = new Youtube();
    edityoutube:Youtube = new Youtube();
    editIndex:number= -1;
    $refs!: {
        form:any
    }
    get list(){
        return this.$store.state.youtubevideos.list;
    }
    get loading(){
        return this.$store.state.youtubevideos.loading;
    }
    get pageSize(){
        return this.$store.state.youtubevideos.pageSize;
    }
    get totalCount(){
        return this.$store.state.youtubevideos.totalCount;
    }
    get currentPage(){
        return this.$store.state.youtubevideos.currentPage;
    }
    getYoutubeId(url){
        if( !this.validateYouTubeUrl(url)){
            return "";
        }
        var video_id = url.split('v=')[1];
        var ampersandPosition = video_id.indexOf('&');
        if(ampersandPosition != -1) {
        video_id = video_id.substring(0, ampersandPosition);
        }
        return video_id;
    }
    validateYouTubeUrl(urlToParse){
        if (urlToParse) {
            var regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
            if (urlToParse.match(regExp)) {
                return true;
            }
        }
        return false;
    }
    @Watch('youtube.videoUrl')
    urlChanged(val: string, oldVal: string) {
        if(val == undefined){
            return false;
        }
        this.youtube.videoId = this.getYoutubeId(val);
    }
    @Watch('youtube.videoUrl')
    urlChanged2(val: Youtube, oldVal: Youtube) {
        this.youtube.videoId = this.getYoutubeId(val);
    }
    async create(){
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'youtubevideos/create',
                    data:this.youtube
                }).then( () =>{
                    this.youtube = new Youtube();
                    this.getpage();
                });
            }
        });
    }
    async save(index){
        this.list[index].title = this.edityoutube.title;
        this.list[index].videoUrl = this.edityoutube.videoUrl;
        this.list[index].videoId = this.getYoutubeId(this.edityoutube.videoUrl);;
        this.editIndex = -1;
        this.edityoutube.id = this.list[index].id;
        await this.$store.dispatch({
            type:'youtubevideos/update',
            data: this.edityoutube
        })
    }
    edit(row,index){ 
        let edit = new Youtube();
        edit.title = row.title;
        edit.videoUrl = row.videoUrl;
        edit.videoId = row.videoId;
        this.edityoutube = edit;
        this.editIndex = index;
    }
    async deleteCat(row,index){
        await this.$store.dispatch({
            type:'youtubevideos/delete',
            data:row
        }).then( () => {
            this.getpage();
        }) ;           
    }
    pageChange(page:number){
        this.$store.commit('youtubevideos/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('youtubevideos/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){         
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        await this.$store.dispatch({
            type:'youtubevideos/getAll',
            data:this.pagerequest
        })
    }
    rules= {
        videoUrl: [
            { required: true, message: this.L('PleasefillName'), trigger: 'blur' }
        ]
    }
    columns=[
        {
            title:this.L('Title'),
            slot:'title'
        },
        {
            title:this.L('VideoId'),
            slot:'videoId'
        },
        {
            title:this.L('VideoUrl'),
            slot:'videoUrl'
        },
        {
            title: this.L('Action'),
            slot: 'action',
            width: 100
        }
    ]
    async created(){
        this.getpage();
    }
}
